import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { ServiceService } from 'packages/client/src/app/services/service.service';
import { BankGqlService } from '../../../../../services/bank.gql-service';
import { RegionGqlService } from '../../../../../services/region.gql-service';
import { BankGridObject, RegionGridObject, TerritorialVzpWorkplaceGridObject } from '@it2go/types';
import { TerritorialVzpWorkplaceGqlService } from '../../../../../services/territorial-vzp-workplace.gql-service';

interface State {
    bankCodes: BankGridObject | null;
    regions: RegionGridObject | null;
    territorialVzpWorkplaces: TerritorialVzpWorkplaceGridObject | null;
}

const defaultState: State = {
    bankCodes: null,
    regions: null,
    territorialVzpWorkplaces: null,
};

@Injectable()
export class ServiceBasicInfoFormStore extends ComponentStoreFactory<State> {

    public readonly svc = inject(ServiceService);
    bankCodes$ = this.data.bankCodes$.pipe(map((it) => {
        return it?.['items'] ?? [];
    }));
    regions$ = this.data.regions$.pipe(map((it) => {
        return it?.['items'] ?? [];
    }));
    territorialVzpWorkplaces$ = this.data.territorialVzpWorkplaces$.pipe(map((it) => {
        return it?.['items'] ?? [];
    }));

    constructor() {
        super(defaultState, inject(Store), inject(ServiceService), inject(BankGqlService), inject(RegionGqlService), inject(TerritorialVzpWorkplaceGqlService));
    }
}
